// --------------------------------------------------------------------------
// Rendered when requesting camera access
// --------------------------------------------------------------------------

import React from 'react';
import lookup from './words.js';
import styles from './index.module.css';

// --------------------------------------------------------------------------

class RequestAccessView extends React.Component {

    // ----------------------------------------------------------------------

    render() {
       
        return (
            <div className={styles.bsRequestAccessPage}>

                <div className={styles.bsHeader}>
                    <h1>{lookup('headingRequestingCameraAccess')}</h1>
                    <p>{lookup('textRequestingCameraAccess')}</p>
                </div>
                <div className={styles.bsCenter}>

                    {lookup('htmlRequestingCameraAccess')}

                </div>
                <div className={styles.bsFooter}>
                    <button className={styles.bsInternalNavButton}  onClick={ (e) => { this.props.onStopScanning(); } }>{lookup('buttonExitBottleScanner')}</button>                                            
                </div>
            
        </div>
        )
    }

}

// --------------------------------------------------------------------------

export default RequestAccessView;

// --------------------------------------------------------------------------
